/**
 * Status classification vocabulary — one entity, one environment.
 *
 * This table is the product. It is defined here, once, and the client renders it from
 * `domain/status.ts`; nothing else is allowed to decide what a cell means.
 */
export const SYNC_STATUSES = ['in_sync', 'drift', 'missing', 'env_only', 'excluded', 'unknown'] as const;
export type SyncStatus = (typeof SYNC_STATUSES)[number];

export type StatusCounts = Record<SyncStatus, number>;

export const emptyCounts = (): StatusCounts =>
    Object.fromEntries(SYNC_STATUSES.map((status) => [status, 0])) as StatusCounts;

export const countStatuses = (statuses: Iterable<SyncStatus>): StatusCounts => {
    const counts = emptyCounts();
    for (const status of statuses) counts[status] += 1;
    return counts;
};

/** The statuses a plan can act on. `excluded` and `in_sync` have nothing to do. */
export type ActionableStatus = Extract<SyncStatus, 'drift' | 'missing'>;
export const isActionable = (status: SyncStatus): status is ActionableStatus =>
    status === 'drift' || status === 'missing';
